import styled from "styled-components/native";
import { View } from "react-native";
import { space } from "../../theming/styledSystem";

export const Container = styled(View)(space);
